const actions = {
    FETCH_PRESCHOOL: 'FETCH_PRESCHOOL',
    FETCH_PRESCHOOL_ATTENDANCE: 'FETCH_PRESCHOOL_ATTENDANCE',

    fetchPreschoolAction: (data) => {
        return {
            type: actions.FETCH_PRESCHOOL,
            data: data
        };
    },
    fetchPreschoolAttendanceAction: (data) => {
        return {
            type: actions.FETCH_PRESCHOOL_ATTENDANCE,
            data: data
        };
    },
};

export default actions;